import { media } from '@/media';
import styled from 'styled-components';

export const ContentsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${media.mobile`
    overflow: hidden;
  `}
`;

export const TitleWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${media.mobile`
    width: 100%;
  `}
`;

export const Title = styled.div`
  overflow: ${(props) => (props.variant === 'medium' ? '' : 'hidden')};
  text-overflow: ${(props) => (props.variant === 'medium' ? '' : 'ellipsis')};
  white-space: ${(props) => (props.variant === 'medium' ? '' : 'nowrap')};
  cursor: pointer;

  :hover {
    text-decoration-line: underline;
  }

  ${media.mobile`
    width: 100%;
  `}
`;

export const TagWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CompanyTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TopicTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TitleImgContainer = styled.div`
  display: flex;
  gap: 16px;
`;
